import { useElasticidadeCruzadaStore } from '../../ElasticidadeCruzada.store';
import styles from './styles.module.scss';

const formatCpi = (value: number) => {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value * 100);
};

export const OptimalCompetitivityCard = () => {
  const { marketShareResponse } = useElasticidadeCruzadaStore();

  const optimalPoint = marketShareResponse?.insights.optimal;

  if (!optimalPoint) return null;

  return (
    <div className={styles.card}>
      <span className={styles.value}>{formatCpi(optimalPoint.x)}%</span>
      <span className={styles.title}>Competitividade ótima</span>
      <p className={styles.description}>O modelo projeta o maior market share</p>
    </div>
  );
};
